<template>
  <v-menu
    class="sv-toolbar-menu"
    offset-y
    content-class="sv-toolbar-menu__content"
  >
    <template v-slot:activator="{ on }">
      <v-btn text v-on="on">
        <v-avatar :size="25">
          <v-icon>mdi-account-circle-outline</v-icon>
        </v-avatar>
        <span id="span-username" class="sv-toolbar-username pl-1">{{
          userName
        }}</span>
        <v-icon size="16">mdi-chevron-down</v-icon>
      </v-btn>
    </template>

    <v-card class="mx-auto">
      <v-list dense class="sv-toolbar-menu__content">
        <v-list-item
          v-if="$can('Profile/view')"
          id="list-item-profile"
          :to="{ name: 'Profile' }"
        >
          <v-list-item-icon>
            <v-icon>mdi-account</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Профиль</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item id="list-item-exit" @click="exit()">
          <v-list-item-icon>
            <v-icon>mdi-exit-run</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Выход</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-card>
  </v-menu>
</template>

<script>
import PermissionMixin from "./../../mixins/CheckPermissionMixin";
import NotificationMixin from "./../../mixins/NotificationMixin";
export default {
  name: "ToolbarProfileMenu",
  mixins: [PermissionMixin, NotificationMixin],
  computed: {
    userName() {
      return this.$store.getters.getUserName;
    }
  },
  methods: {
    exit() {
      this.$store
        .dispatch("logout")
        .then(() => {
          this.$router.push({ name: "Login" });
        })
        .catch(error => {
          this.sendError(error);
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.fullUsername {
  word-break: keep-all;
}
.sv-toolbar-username {
  text-transform: none;
}
</style>
